
import { LogoutComponent } from './logout/logout.component';
import { HomeComponent } from './home/home.component';

import { AuthGuard, NotLoggedInGuard, LoginComponent, ForgotComponent } from '../user';
import { DialogGuard } from '../common';

import { Route } from '@angular/router';
import { MembershipBenefitsComponent } from './membership-benefits/membership-benefits.component';
import { HowToWatchComponent } from './how-to-watch/how-to-watch.component';
import { ProductionCalendarComponent } from './production-calendar/production-calendar.component';
import { WatchLiveComponent } from './watch-live/watch-live.component';
import { WatchPageComponent } from './watch-page/watch-page.component';
import { PodcastsComponent } from './podcasts/podcasts.component';
import { PodcastComponent } from './podcast/podcast.component';
import { RedirectionComponent } from './redirection/redirection.component';
import { SpotJumpComponent } from './spot-jump/spot-jump.component';
import { PageNotFoundComponent } from '@tytapp/common-ui';
import { FeedComponent } from './feed/feed.component';
import { JobsPageComponent } from './jobs-page/jobs-page.component';
import { SignUpComponent } from 'user/sign-up/sign-up.component';
import { TopicFeedPageComponent } from './topic-feed-page/topic-feed-page.component';
import { TopicsIndexComponent } from './topics-index/topics-index.component';
import { SettingsComponent } from './settings/settings.component';
import { FinishOauthSignupComponent } from './finish-oauth-signup/finish-oauth-signup.component';
import { OfflinePageComponent } from './offline-page/offline-page.component';
import { RedemptionComponent } from './redemption/redemption.component';
import { CompanyImpactPageComponent } from './company-impact-page/company-impact-page.component';
import { ConfirmAccountComponent } from './confirm-account/confirm-account.component';
import { ConfirmationRequiredComponent } from './confirmation-required/confirmation-required.component';
import { UserAuthMediatorComponent } from '@tytapp/user/user-auth-mediator/user-auth-mediator.component';
import {AddThisComponent} from '@tytapp/add-this/add-this.component';

export const ROUTES: Route[] = [

    /* LAZY */

    {
        path: 'engineering',
        loadChildren: () => import('./pages/tech-pages/tech-pages.module').then(m => m.TechPagesModule)
    },
    {
        path: 'stories/edit',
        loadChildren: () => import('./pages/article-editor-pages/article-editor-pages.module').then(m => m.ArticleEditorPagesModule)
    },
    {
        path: 'stories',
        loadChildren: () => import('./pages/article-pages/article-pages.module').then(m => m.ArticlePagesModule)
    },
    {
        path: 'polls',
        loadChildren: () => import('./pages/poll-pages/poll-pages.module').then(m => m.PollPagesModule)
    },
    {
        path: 'petitions',
        loadChildren: () => import('./pages/petition-pages/petition-pages.module').then(m => m.PetitionPagesModule)
    },
    {
        path: 'affiliate',
        loadChildren: () => import('./pages/tap-pages/tap-pages.module').then(m => m.TapPagesModule)
    },
    {
        // temporary, this was changed during development, left in to avoid
        // any dangling links
        path: 'landing/affiliate',
        redirectTo: 'affiliate/landing'
    },
    {
        path: 'community',
        loadChildren: () => import('./pages/community-pages/community-pages.module').then(m => m.CommunityPagesModule)
    },
    {
      path: 'comments',
      loadChildren: () => import('./pages/embedded-comment/embedded-comment.module').then(m => m.EmbeddedCommentModule)
    },



    // this is better handled as a redirect at Cloudflare to ensure GTM tagging etc
    // {
    //   path: 'join',
    //   component: RedirectionComponent,
    //   data: { id: 'join' }
    // },

    ///////////////////////
    // VANITY URLS
    { path: 'investigates', redirectTo: '/stories/franchise/4vZLCHuQrYE4uKagy0oyMA' },
    { path: '5burningquestions', redirectTo: '/stories/franchise/6kOeWkXabmEmeqWOuuwyUA' },
    { path: '5bq', redirectTo: '/stories/franchise/6kOeWkXabmEmeqWOuuwyUA' },
    { path: 'ringoffire', redirectTo: '/stories/franchise/18k4AzKgwoMS4CgqKi62Io' },
    { path: 'morenews', redirectTo: '/stories/franchise/18k4AzKgwoMS4CgqKi62Io' },
    { path: 'reportingin', redirectTo: '/shows/4IhovMPNRKsoQUyys0oi6q' },
    { path: 'ri', redirectTo: '/shows/4IhovMPNRKsoQUyys0oi6q' },
    { path: 'tyt', redirectTo: '/shows/6e6Xst82zYACGGyweSOkMg' },
    { path: 'theyoungturks', redirectTo: '/shows/6e6Xst82zYACGGyweSOkMg' },
    { path: 'pg', redirectTo: '/shows/1GluS8los444qmMUW8koOq' },
    { path: 'postgame', redirectTo: '/shows/1GluS8los444qmMUW8koOq' },
    { path: 'specialevents', redirectTo: '/shows/60DdTKm1qgCsQ0Q6GuCes6' },
    { path: 'nofilter', redirectTo: '/shows/5eM6jGI2pGUiquc88C2iCC' },
    { path: 'nf', redirectTo: '/shows/5eM6jGI2pGUiquc88C2iCC' },
    { path: 'ap', redirectTo: '/shows/6Rhy44YyOcocg4iqmCMYMI' },
    { path: 'aggressiveprogressives', redirectTo: '/shows/6Rhy44YyOcocg4iqmCMYMI' },
    { path: 'breakdown', redirectTo: '/shows/1b5wP1nYVgcImU2EMoeMaM' },
    { path: 'thebreakdown', redirectTo: '/shows/1b5wP1nYVgcImU2EMoeMaM' },
    { path: 'damagereport', redirectTo: '/shows/5Rz3k3CD7yyU488YokUoWi' },
    { path: 'thedamagereport', redirectTo: '/shows/5Rz3k3CD7yyU488YokUoWi' },
    { path: 'happyhalfhour', redirectTo: '/shows/rqjzepDylaEaQwmaYYWKm' },
    { path: 'hhh', redirectTo: '/shows/rqjzepDylaEaQwmaYYWKm' },
    { path: 'hh', redirectTo: '/shows/rqjzepDylaEaQwmaYYWKm' },
    { path: 'murderwithfriends', redirectTo: '/shows/WSlENpFzUYu8kO2s6GEkM' },
    { path: 'mwf', redirectTo: '/shows/WSlENpFzUYu8kO2s6GEkM' },
    { path: 'jimmydore', redirectTo: '/shows/103gDLt2SeAeEi2UQwAg0W' },
    { path: 'tjds', redirectTo: '/shows/103gDLt2SeAeEi2UQwAg0W' },
    { path: 'jd', redirectTo: '/shows/103gDLt2SeAeEi2UQwAg0W' },
    { path: 'nerdalert', redirectTo: '/shows/59kaghMS3eqIUgYOEmooyq' },
    { path: 'na', redirectTo: '/shows/59kaghMS3eqIUgYOEmooyq' },
    { path: 'mmm', redirectTo: '/shows/4iYvJ9zJUkuaeYOSqcaCaM' },
    { path: 'oldschool', redirectTo: '/shows/3cIboFbvKEW0uG0EC0GMoQ' },
    { path: 'os', redirectTo: '/shows/3cIboFbvKEW0uG0EC0GMoQ' },
    { path: 'interviews', redirectTo: '/shows/4Ap2dAjhqwGOcC8GUig2MA' },
    { path: 'tytinterviews', redirectTo: '/shows/4Ap2dAjhqwGOcC8GUig2MA' },
    { path: 'poptrigger', redirectTo: '/shows/6BbVnUNYzeks6Gim6sSQQ6' },
    { path: 'pt', redirectTo: '/shows/6BbVnUNYzeks6Gim6sSQQ6' },
    { path: 'rebelhq', redirectTo: '/shows/38HQ0d2oysK6O8i8qcoicC' },
    { path: 'hq', redirectTo: '/shows/38HQ0d2oysK6O8i8qcoicC' },
    { path: 'toure', redirectTo: '/shows/5wKHrrXZSgAuU6Eycqk0yu' },
    { path: 'toureshow', redirectTo: '/shows/5wKHrrXZSgAuU6Eycqk0yu' },
    { path: 'touré', redirectTo: '/shows/5wKHrrXZSgAuU6Eycqk0yu' },
    { path: 'sports', redirectTo: '/shows/3RXuDnkCSQssICWugq2C40' },
    { path: 'tytsports', redirectTo: '/shows/3RXuDnkCSQssICWugq2C40' },
    { path: 'wethepeople', redirectTo: '/shows/4Vg44nEHwciYQaq8uoAICo' },
    { path: 'wtp', redirectTo: '/shows/4Vg44nEHwciYQaq8uoAICo' },
    { path: 'wtf', redirectTo: '/shows/2Nq6VLn81igGM4OsuCGeyk' },
    { path: 'whattheflick', redirectTo: '/shows/2Nq6VLn81igGM4OsuCGeyk' },

    ////////////////////

    {
        path: 'account',
        component: RedirectionComponent,
        data: { id: 'account' }
    },
    {
        path: 'profile',
        component: RedirectionComponent,
        data: { id: 'join' }
    },
    {
        path: 'offline',
        component: OfflinePageComponent
    },
    {
        path: 'oauth/welcome',
        component: FinishOauthSignupComponent
    },
    {
        path: 'oauth/welcome/:step',
        component: FinishOauthSignupComponent
    },
    {
        path: 'profile',
        component: RedirectionComponent,
        data: { id: 'join' }
    },
    {
        path: 'spot/:id',
        component: SpotJumpComponent
    },
    {
        path: 'articles',
        redirectTo: 'stories'
    },
    {
        path: 'archive',
        component: ProductionCalendarComponent
    },
    {
        path: 'archive/:month',
        component: ProductionCalendarComponent
    },
    {
        path: 'live/streams/:streamID',
        component: WatchLiveComponent
    },
    {
        path: 'watch/edit',
        loadChildren: () => import('./pages/video-editor-pages/video-editor-pages.module').then(m => m.VideoEditorPagesModule)
    },
    {
        path: 'watch/:show/:production/:mode/:vod',
        component: WatchPageComponent
    },
    {
        path: 'watch/:production/:mode/:vod',
        component: WatchPageComponent
    },
    {
        path: 'watch/:production/:mode',
        component: WatchPageComponent
    },

    {
        path: 'listen/:show/:production/:mode/:vod',
        component: WatchPageComponent
    },
    {
        path: 'listen/:production/:mode/:vod',
        component: WatchPageComponent
    },
    {
        path: 'listen/:production/:mode',
        component: WatchPageComponent
    },

    { path: 'podcast', redirectTo: 'podcasts' },
    {
        path: 'podcasts',
        component: PodcastsComponent
    },
    {
        path: 'podcasts/:id',
        component: PodcastComponent,
        canActivate: [DialogGuard],
        data: { dialog: PodcastComponent }
    },

    /* SHOWS */

    {
        path: 'shows',
        loadChildren: () => import('./pages/show-pages/show-pages.module').then(m => m.ShowPagesModule)
    },
    {
        path: 'episodes/:id',
        redirectTo: 'shows/-/episodes/:id'
    },

    /* LIVE STREAMING */

    {
        path: 'live',
        loadChildren: () => import('./pages/live-pages/live-pages.module').then(m => m.LivePagesModule)
    },
    {
        path: 'memberslive',
        redirectTo: 'live/qc-members'
    },
    {
        path: 'LIVE',
        redirectTo: 'live'
    },
    {
        path: 'Live',
        redirectTo: 'live'
    },

    /* ABOUT */

    {
        path: 'about',
        loadChildren: () => import('./pages/about-pages/about-pages.module').then(m => m.AboutPagesModule)
    },
    { path: 'honor-roll', redirectTo: 'about/honor-roll' },
    { path: 'faq', redirectTo: 'about/faq' },
    { path: 'faqs', redirectTo: 'about/faq' },
    //{ path: 'contact', redirectTo: 'about/contact' },
    { path: 'company', redirectTo: 'about/company' },
    { path: 'support', redirectTo: 'about/support' },

    /* LOGIN */

    {
        path: 'login',
        component: HomeComponent,
        data: { dialog: UserAuthMediatorComponent },
        canActivate: [NotLoggedInGuard, DialogGuard]
    },

    {
        path: 'signin',
        component: HomeComponent,
        data: {dialog: LoginComponent},
        canActivate: [NotLoggedInGuard, DialogGuard]
    },

    {
        path: 'signup',
        component: SignUpComponent,
        canActivate: [NotLoggedInGuard]
    },

    {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'settings/:section',
        component: SettingsComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'settings/:section/:subsection',
        component: SettingsComponent,
        canActivate: [AuthGuard]
    },

    {
        path: 'login/confirmation-required',
        component: HomeComponent,
        data: {
            dialog: ConfirmationRequiredComponent
        },
        canActivate: [AuthGuard, DialogGuard]
    },
    {
        path: 'login/confirm/:token',
        component: HomeComponent,
        data: {
            dialog: ConfirmAccountComponent
        },
        canActivate: [NotLoggedInGuard, DialogGuard]
    },

    {
        path: 'login/forgot',
        component: HomeComponent,
        data: {
            dialog: ForgotComponent
        },
        canActivate: [NotLoggedInGuard, DialogGuard]
    },
    {
        path: 'login/forgot/:token',
        component: HomeComponent,
        data: {
            dialog: ForgotComponent
        },
        canActivate: [NotLoggedInGuard, DialogGuard]
    },

    // Account

    {
        path: 'logout',
        component: LogoutComponent,
        canActivate: [AuthGuard]
    },

    // Sponsorship
    {
        path: 'redeem',
        component: RedemptionComponent
    },

    // Shell

    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'topics',
        component: TopicsIndexComponent
    },
    {
        path: 'topics/:topic',
        component: TopicFeedPageComponent
    },
    {
        path: 'feed',
        component: FeedComponent
    },

    {
        path: 'feed/:content',
        component: FeedComponent
    },

    {
        path: 'careers',
        component: JobsPageComponent
    },

    {
        path: 'careers/:id',
        component: JobsPageComponent
    },

    {
        path: 'payment-confirmation/:offerSetUUID/:offerUUID',
        redirectTo: '/'
    },

    {
        path: 'membership-benefits',
        component: MembershipBenefitsComponent
    },

    { path: 'watch', redirectTo: 'how-to-watch', pathMatch: 'full' },
    {
        path: 'how-to-watch',
        component: HowToWatchComponent
    },
    {
        path: 'impacts',
        component: CompanyImpactPageComponent
    },

    {
        path: 'engn/add-this',
        component: AddThisComponent
    },

    /* HOME */

    {
        path: '',
        component: HomeComponent,
        pathMatch: 'full'
    },

    /* NOT FOUND */

    {
        path: '**',
        component: PageNotFoundComponent
    }
];

PageNotFoundComponent.routes = ROUTES;
